// src/App.js
import React, { Suspense, lazy, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Navbar from './Components/navbar';
import Footer from './Components/footer';

// Lazy-loaded components
const Home = lazy(() => import('./Pages/Home'));
const About = lazy(() => import('./Pages/About'));
const Contact = lazy(() => import('./Pages/Contact'));
const NotFound = lazy(() => import('./Pages/NotFound'));
const LogoDesign = lazy(() => import('./Pages/logoDesign'));
const ProductFlyer = lazy(() => import('./Pages/productFlayer'));
const GraphicDesign = lazy(() => import('./Pages/graphicDesign'));
const WebDevelopment = lazy(() => import('./Pages/webDevelopment'));
const AppDevelopment = lazy(() => import('./Pages/appDevelopment'));
const SeeAll = lazy(() => import('./Features/AllProjects'));

// Route titles map
const routeTitles = {
  '/': 'Netsage Technologies',
  '/about': 'Netsage | About Us',
  '/contact': 'Netsage | Contact Us',
  '/logo-designing': 'Netsage | Logo Designing',
  '/product-flyer': 'Netsage | Product Flyer',
  '/graphic-designing': 'Netsage | Graphic Designing',
  '/web-development': 'Netsage | Web Development',
  '/app-development': 'Netsage | App Development',
  '/see-all': 'Netsage | See All'
};

const SetTitle = () => {
  const location = useLocation();

  useEffect(() => {
    document.title = routeTitles[location.pathname] || 'Not Found';
  }, [location]);

  return null;
};

const App = () => {
  return (
    <Router>
      <div className="App">
        <Navbar />
        <Suspense fallback={<LoadingSpinner />}>
          <main className="mt-20 min-h-screen">
            <SetTitle />
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/logo-designing" element={<LogoDesign />} />
              <Route path="/product-flyer" element={<ProductFlyer />} />
              <Route path="/graphic-designing" element={<GraphicDesign />} />
              <Route path="/see-all" element={<SeeAll />} />
              <Route path="/web-development" element={<WebDevelopment />} />
              <Route path="/app-development" element={<AppDevelopment />} />
              <Route path="/about" element={<About />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </main>
        </Suspense>
        <Footer />
      </div>
    </Router>
  );
};

const LoadingSpinner = () => (
  <div className="flex justify-center items-center h-screen">
    <div className="relative inline-flex">
      <div className="w-8 h-8 bg-blue-500 rounded-full"></div>
      <div className="w-8 h-8 bg-blue-500 rounded-full absolute top-0 left-0 animate-ping" style={{ animationDuration: '4s' }}></div>
      <div className="w-8 h-8 bg-blue-500 rounded-full absolute top-0 left-0 animate-pulse" style={{ animationDuration: '4s' }}></div>
    </div>
  </div>
);

export default App;
